import {
  Autocomplete,
  autocompleteClasses,
} from '@mui/material';
import styled from 'styled-components';

export const StyledAutocomplete = styled(Autocomplete)`
  width: 100%;

  .${autocompleteClasses.inputRoot} {
    background-color: #fcfcfc;
    border-radius: 8px;
    padding-right: 0 !important;
  }

  .${autocompleteClasses.option} {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 12px 16px;

    &:hover {
      background-color: #eef6ff;
    }
  }
`;

export const LogoWrapper = styled.div<{ small?: boolean }>`
  width: ${({ small }): string => {
    return small ? '24px' : '64px';
  }};
  height: ${({ small }): string => {
    return small ? '24px' : '64px';
  }};
  border-radius: ${({ small }): string => {
    return small ? '4px' : '8px';
  }};
  background: #f5f5f5;
  display: flex;
  align-items: center;
  margin-right: 8px;
  justify-content: center;
  overflow: hidden;
  position: relative;
`;

export const LogoImg = styled.img`
  max-width: 100%;
  max-height: 100%;
`;
